import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import { compose } from '../core/compose.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  backgroundColor: {
    property: 'backgroundColor'
  },
  color: {
    property: 'color'
  },
  opacity: {
    property: 'opacity'
  }
};
const colorShorthandConfig = {};
colorShorthandConfig.bg = {
  properties: ['color', 'backgroundColor']
};
colorShorthandConfig.bgColor = config.backgroundColor;
const color = compose(system(config), system(colorShorthandConfig));

export { color };
